enum StatusSituacao {
  Incompleta = 'Incompleta',
  RevisaoAIH = 'RevisaoAIH',
  PreReserva = 'PreReserva',
  EmAnalise = 'EmAnalise',
  Pendente = 'Pendente',
  Autorizada = 'Autorizada',
  Negada = 'Negada',
  Agendada = 'Agendada',
  EmCancelamento = 'EmCancelamento',
  Cancelada = 'Cancelada',
  Enviado = 'Enviado',
  NovaSolicitacaoParticular = 'NovaSolicitacaoParticular',
  NovaSolicitacaoDeOrcamentoParticularAvulso = 'NovaSolicitacaoDeOrcamentoParticularAvulso',
}

export default {
  StatusSituacao,
}
